import { FGTMEventEnum } from '@/types/gtm';
import pushGTMDataLayer from './pushGTMDataLayer';
const sendGTMPageView = (dataLayer) => {
    pushGTMDataLayer({
        ...dataLayer,
        page_referrer: window.pageReferrer,
        page_referrer_name: window.pageReferrerName,
        event: FGTMEventEnum.page_view
    });
    window.pageReferrer = dataLayer.custom_page_path;
    window.pageReferrerName = dataLayer.page_name;
};
export default sendGTMPageView;
